<template>
  <TableResponsiveContainer>
    <table
      class="TableBasicPreview"
      table
      table--borderless
    >
      <tbody>
        <tr
          v-for="(item, index) in data"
          :key="`item-${index}`"
        >
          <td class="TableBasicPreview__label">{{ item.label }}</td>
          <td
            v-if="item.link"
            class="TableBasicPreview__info">
            <a
              :href="`https://${item.info}`"
              target="_blank"
            >{{ item.info }}</a>
          </td>
          <td
            v-else
            class="TableBasicPreview__info"
          >{{ item.info }}</td>
        </tr>
      </tbody>
    </table>
  </TableResponsiveContainer>
</template>

<script>
import TableResponsiveContainer
  from '@/components/table/ResponsiveContainer.vue';

export default {
  name: 'TableBasicPreview',
  components: {
    TableResponsiveContainer,
  },
  props: {
    data: {
      type: Array,
      required: true,
    },
  },
  created() {
    console.log('PROP', this.data);
  },
};
</script>

<style scoped lang="scss">
.TableBasicPreview__label {
  font-size: 16px;
  vertical-align: middle;
  color: $color--primary;
  padding: 10px 15px;
}
.TableBasicPreview__info {
  @include roboto300;
  vertical-align: middle;
  color: #000;
  padding-left: 45px;
}
</style>
